import {Swiper, SwiperClass, SwiperSlide} from "swiper/react";
import useIsMobile from '../../../hook/useIsMobile';
import 'swiper/css';
import { FreeMode, Pagination } from "swiper/modules";
import FadeInUp from "../../../components/FadeInUp";

export default function ProblemStatement() {

  const problemsData = [
    {
      "index": 1,
      "title": "길 위의 위험\n피할 수 없을 때",
      "description": "울퉁불퉁한 길과 장애물에 밀려\n보행자는 차도로 떠밀립니다."
    },
    {
      "index": 2,
      "title": "누군가 곁에\n있어 주길 바라지만",
      "description": "위급한 상황에서도\n우린 점점 혼자가 됩니다."
    },
    {
      "index": 3,
      "title": "말을 꺼내기도, 손을 뻗기도\n너무 어려운 순간",
      "description": "사고를 당해도 직접 신고해야만 하는\n구조는 여전히 그대로입니다."
    }
  ];

  const featuresData = [
    {
      "index": 1,
      "content": "예기치 못한\n충돌과 전복 사고에 대비"
    },
    {
      "index": 2,
      "content": "전동차 사고에 즉각 대응하는\n응급 호출기"
    },
    {
      "index": 3,
      "content": "위급한 순간\n자동으로 구조를 요청"
    }
  ]

  const isMobile = useIsMobile();

  return (
    <section>
      <div className='wrapper top-space flex flex-col gap-[80px] lg:gap-[200px]'>
        {
          problemsData.map(item => (
            <div
              key={item.index}
            >
              <FadeInUp>
                <h3 className='font-bold text-title2 lg:text-display2 text-label-400 whitespace-pre-line'>
                  {item.title}
                </h3>
              </FadeInUp>

              <FadeInUp
                className='mt-[12px] lg:mt-[32px] font-medium text-body1 lg:text-title3 text-label-100 whitespace-pre-line'>
                {item.description}
              </FadeInUp>

              <FadeInUp>
                <img 
                  alt='문제점'
                  src={`${process.env.REACT_APP_STATIC_URL}/images/main/problem${item.index}.jpg`}
                  className='mt-[32px] lg:mt-[60px] object-cover object-center aspect-[880/500] rounded-[12px] lg:rounded-[28px]'/>
              </FadeInUp>
            </div>
          ))
        }
      </div>

      <div className='wrapper top-space'>
        <FadeInUp>
          <h2 className='font-bold text-title2 lg:text-display2 text-label-400'>
            링콜을 믿을 수 있습니다.
          </h2>
        </FadeInUp>
        <FadeInUp>
          <div className='mt-[12px] lg:mt-[32px] font-medium text-body1 lg:text-title3 text-label-100'>
            항상 위험한 상황을 대비하세요.
          </div>
        </FadeInUp>

        <FadeInUp>
          {
            isMobile ? 
            <Swiper
              freeMode={true}
              grabCursor={true}
              pagination={true}
              slidesPerView='auto'
              spaceBetween={30}
              className='mt-[32px]'
              modules={[Pagination, FreeMode]}
              style={{
                "--swiper-pagination-color": "#ff692e",
              }}
            >
              {
                featuresData.map(item => (
                  <SwiperSlide className='w-[300px]'>
                    <div
                      key={item.index}
                      className='relative p-[32px] w-[300px] aspect-square bg-[#FAFAFA] rounded-[16px] lg:rounded-[20px] font-semibold text-heading1 whitespace-pre-line'
                    >
                      {item.content}

                      <img 
                        src={`${process.env.REACT_APP_STATIC_URL}/images/main/problem_card_icon${item.index}.png`}
                        className='absolute bottom-[32px] right-[32px] w-1/3 aspect-square' 
                      />
                    </div>
                  </SwiperSlide>
                ))
              }
            </Swiper>
            :
            <div className='mt-[60px] flex gap-[17px]'>
              {
                featuresData.map(item => (
                  <div
                    key={item.index}
                    className='relative p-[32px] flex-1 aspect-square bg-[#FAFAFA] rounded-[20px] font-semibold text-heading1 whitespace-pre-line'
                  >
                    {item.content}

                    <img 
                      src={`${process.env.REACT_APP_STATIC_URL}/images/main/problem_card_icon${item.index}.png`}
                      className='absolute bottom-[32px] right-[32px] w-1/3 aspect-square' 
                    />
                  </div>
                ))
              }
            </div>
          }
        </FadeInUp>
        
      </div>

      <div 
        className='w-full top-space px-[5%] py-[140px] text-center bg-cover bg-center bg-no-repeat'
        style={{ backgroundImage: `url(${process.env.REACT_APP_STATIC_URL}/images/main/problem_disaster.jpg)`}}
      >
        <div className='font-bold text-title3 lg:text-display3 text-white'>재난 상황 속, 구조의 사각지대</div>
        <div className='mt-[40px] text-body1 lg:text-heading1 text-white'>
          지진이나 산불이 발생하면, 보행이 어려운 사람은 스스로 대피하지 못하고<br/>
          구조대는 위치를 몰라 수색에 시간을 허비합니다. <br/>
          움직일 수 없는 사람과, 찾지 못하는 구조대. 그 간극은 여전히 이어지고 있습니다.
        </div>
      </div>
    </section>
  )
}